module.exports = ".list-group-item .icon{\n    margin-right: unset;\n}\n.media a {\n    color: #818c94;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/other/enterprise/enterprise.component.css
// module id = ./src/app/pages/admin/icontact/setting/other/enterprise/enterprise.component.css
// module chunks = main